import { BaseEvent } from "./event"

export interface SMTPCreatedEvent extends BaseEvent {}

export interface SMTPUpdatedEvent extends BaseEvent {}
